module.exports = __webpack_public_path__ + "static/platonic_partnership-8802e006b789307cfce812bd0f8954c3.svg";